/* eslint-disable */
import React from 'react';
import b from './devsBar.module.css';
import { Ic } from './devsIcons';
import { BAR_AXES, AXIS_NAME, axisValues, summary, labelOf } from './devsBarModel';

// The three axes that stay on the bar (BAR_AXES): one dropdown trigger each. They sit in ONE fold cell
// (data-f=ddw) so the fit can fold the whole group into Filters (fold step f4).
export default function DevsBarAxes({ opts, devFilters, openKey, onOpen }) {
  return (
    <div className={`${b.cw} ${b.ddw}`} data-f="ddw">
      <div className={b.cn}>
        {BAR_AXES.map((k) => {
          const sel = axisValues(devFilters, k), key = `dd:${k}`, on = sel.length > 0, o = openKey === key;
          const full = AXIS_NAME[k] + (on ? ': ' + sel.map((v) => labelOf(opts, k, v)).join(', ') : '');
          return (
            <button key={k} type="button" data-anchor={key} data-fk={key} className={`${b.dd} ${on ? b.on : ''} ${o ? b.open : ''}`} aria-haspopup="dialog" aria-expanded={o} aria-label={full} title={full} onClick={(e) => { e.stopPropagation(); onOpen(key); }}>
              <span className={b.fl}>{AXIS_NAME[k]}</span>{on && <span className={b.fv}>{summary(opts, devFilters, k)}</span>}<Ic n="chev" cls={b.chev} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
